import * as React from 'react';
export const eyeClosedSvg = React.forwardRef(function eyeClosedSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M14.53 2.53a.75.75 0 0 0-1.06-1.06l-1.366 1.365C10.871 2.172 9.444 1.75 8 1.75c-2.007 0-3.977.814-5.445 1.956C1.114 4.828 0 6.396 0 8c0 1.604 1.114 3.172 2.555 4.294l.051.04L1.47 13.47a.75.75 0 1 0 1.06 1.06l1.366-1.365c1.233.663 2.66 1.085 4.104 1.085 2.007 0 3.977-.814 5.445-1.956C14.886 11.172 16 9.604 16 8c0-1.604-1.114-3.172-2.555-4.294a7.156 7.156 0 0 0-.051-.04L14.53 2.53Zm-3.542 1.422C10.05 3.514 9.018 3.25 8 3.25c-1.618 0-3.273.667-4.524 1.64C2.2 5.884 1.5 7.065 1.5 8s.699 2.116 1.976 3.11c.066.051.133.102.202.152l1.375-1.375a3.5 3.5 0 0 1 4.835-4.835l1.1-1.1ZM8.782 6.158A2 2 0 0 0 6.159 8.78l2.623-2.623Zm-3.77 5.89 7.31-7.31c.069.05.136.1.202.152C13.8 5.884 14.5 7.065 14.5 8s-.699 2.116-1.976 3.11c-1.251.973-2.906 1.64-4.524 1.64-1.018 0-2.05-.264-2.988-.702Z',
    }),
  );
});
eyeClosedSvg.defaultProps = {
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var eyeClosed = {
  category: 'icon',
  colorable: true,
  name: 'eyeClosed',
  svg: eyeClosedSvg,
};
